import { createContext, LabelHTMLAttributes, ReactNode, useContext } from 'react'

interface Context {
  labelProps: LabelHTMLAttributes<HTMLLabelElement>
  label?: ReactNode
}

export const LabelContext = createContext<Context | null>(null)

export const useLabelContext = () => {
  const context = useContext(LabelContext)
  if (!context) {
    throw new Error('LabelContext must be used within a LabelContext.Provider')
  }
  return context as Context
}
